/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

import { Line3 } from 'three';

import { isVector3Like } from './isVector3Like.js';

export const isLine3 = (o: any): o is Line3 =>
  !!o?.isLine3 || (isVector3Like(o?.start) && isVector3Like(o?.end));
